module.exports = __webpack_public_path__ + "img/02.e2b9af7a.jpg";